import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { General } from "../../interfaces/general";
import { FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';

@Component({
	selector: "app-tutor",
	templateUrl: "./tutor.component.html",
	styleUrls: ["./tutor.component.css"],
})
export class TutorComponent implements OnInit {
	@Input() catalogos: General;
	@Input() estados: Array<any>;
	@Input() DatosTutor: FormGroup;
	@Input() listaCURPS: Array<any>
	@Output() conCurp = new EventEmitter()

	loading = false;
	tieneCURP = false;
	paises: any;
	extranjeroEs = false;
	pais: string;
	municipios: Array<any>;
	constructor(private serviciosGenerales : ServiciosGeneralesService,
				private snackBar: MatSnackBar) {}

	ngOnInit(): void {
		console.log(this.estados);
		this.escucharCURP()
		this.listarMunicipios(this.DatosTutor.value.Personas_EntidadFederativaID)
		this.DatosTutor.get('Personas_Nombre').disable()
		this.DatosTutor.get('Personas_ApellidoPaterno').disable()
		this.DatosTutor.get('Personas_ApellidoMaterno').disable()
		this.DatosTutor.get('Personas_Genero').disable()
		this.DatosTutor.get('Personas_EntidadFederativaID').disable()
		this.DatosTutor.get('Personas_MunicipioID').disable()
	}

	escucharCURP() {
		this.DatosTutor.get("Personas_CURP")
			.valueChanges.pipe(debounceTime(1500))
			.subscribe((CURP) => {
				return CURP.length === 18 &&
						this.listaCURPS.filter(value => value === CURP).length === 0
										? this.obtenerdatosCURP(CURP) :
										this.openSnackBar('Esta CURP ya fue registrada en esta solicitud','Entendido');
			});
	}
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
		duration: 2000,
		});
	}
	obtenerPaises(): void {
		this.serviciosGenerales.listadoPaises().subscribe((res) => {
			this.paises = res;
			const pais = this.paises.filter(
				(pais) => pais.ISO_A3 === this.pais
			);
			this.DatosTutor.get("Personas_PaisID").setValue(pais.ID);
		});
	}
	idEstadoMunicipioCURP (estadoID, MunicipioID) {
		const idEstadoDB = this.estados.filter(estado => +estado.Codigo === +estadoID)
		console.log(idEstadoDB)
		this.serviciosGenerales.listadoMunicipios(idEstadoDB[0].ID).subscribe((res) => {
			this.municipios = res
			const idMunicipioID = this.municipios.filter(municipio => +municipio.Codigo === +MunicipioID)
			this.DatosTutor.get('Personas_EntidadFederativaID').setValue(idEstadoDB[0].ID);
			this.DatosTutor.get('Personas_MunicipioID').setValue(idMunicipioID[0].ID);
		});
	}
	listarMunicipios(idEstado: number) {

		this.serviciosGenerales.listadoMunicipios(idEstado).subscribe((res) => {
			this.municipios = res;
		});
	}
	obtenerdatosCURP(CURP: string) {
		this.tieneCURP = false;
		this.serviciosGenerales.obtenerDatosCURP(CURP).subscribe((res) => {

				this.tieneCURP = res.Ok;

				if(this.tieneCURP) {
					const fechaCumpleaños = this.getFecha(res.Data.BirthDate)
					console.log(fechaCumpleaños)
					if(fechaCumpleaños > 18 && fechaCumpleaños < 65) {
						if(res.Data.Country === "MEX") {
							this.mostrarInformacion(res.Data)
							// this.obtenerListaEstadosID()
							this.extranjeroEs = false;
						} else {
							this.pais = res.Data.Country
							this.extranjeroEs = true;
							this.mostrarInformacion(res.Data)
							this.obtenerPaises();
						}
					} else {
						this.openSnackBar('El tutor debe de tener mas de 18 años','Entendido')
					}
				} else {
					this.openSnackBar('CURP no valida','Entendido')
				}
		})
	}

	getFecha (fecha:string) {
		const datos = fecha.split('/')
		const ano = datos[2]
		const mes = datos[1]
		const dia = datos[0]

		const nuevaFecha = `${ano}-${mes}-${dia}T00:00:00`
		this.DatosTutor.get('Personas_FechaNacimiento').setValue(nuevaFecha)
		const fechaCumpleanos:number = this.calculateAge(new Date(+ano,+mes,+dia))
		this.DatosTutor.get('Personas_Edad').setValue(fechaCumpleanos)
		return fechaCumpleanos
	}
	calculateAge(birthday) {
		const ageDifMs = Date.now() - birthday.getTime();
		const ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	}
	mostrarInformacion(persona) {

		console.log(persona)
		if (persona !== undefined) {
			if(persona.Country === "MEX") {
				this.idEstadoMunicipioCURP(+persona.StateId, persona.CityId)
			}
			else {
				this.DatosTutor.get('Personas_EntidadFederativaID').setValue(1001);
			}
			this.getFecha(persona.BirthDate)
			this.DatosTutor.get('Personas_Nombre').setValue(persona.Name);
			this.DatosTutor.get('Personas_ApellidoPaterno').setValue(persona.Lastname);
			this.DatosTutor.get('Personas_ApellidoMaterno').setValue(persona.Surname);
			this.DatosTutor.get('Personas_Genero').setValue(persona.Genre);
			this.conCurp.emit()
		}
	}


}
